import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type {
    FlowTemplateRecord,
    FlowTemplatesSliceState,
} from './flowTemplates.type';

export const FLOW_TEMPLATES_REDUCER_NAME = 'flowTemplates';

const flowTemplatesInitialState: FlowTemplatesSliceState = {
    data: [],
};

export const flowTemplatesSlice = createSlice({
    name: FLOW_TEMPLATES_REDUCER_NAME,
    initialState: flowTemplatesInitialState,
    reducers: {
        setFlowTemplates: (
            state,
            action: PayloadAction<FlowTemplateRecord[]>,
        ) => {
            state.data = action.payload;
        },
        resetFlowTemplates: (state) => {
            state.data = [];
        },
    },
});

export const { setFlowTemplates, resetFlowTemplates } =
    flowTemplatesSlice.actions;

export const flowTemplatesReducer = flowTemplatesSlice.reducer;
